import { CoreButton } from '@components'
import { formatCurrencyForDisplay } from '@utils'
import { useMerchantQry, usePayApplicationFeeQry } from 'mmfintech-backend-api'
import type { SimpleCallback } from 'mmfintech-backend-api/types'
import { GlobalContext, getCurrencySymbol, tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useContext } from 'react'

import './applicationFeeInfoModal.scss'

interface ApplicationFeeInfoProps {
  accountId: number
  onSuccess: SimpleCallback
}

const ApplicationFeeInfoModal = ({ accountId, onSuccess }: ApplicationFeeInfoProps) => {
  const { modalHide } = useContext(GlobalContext)

  const { merchant } = useMerchantQry()
  const { accountSetupFee } = merchant || {}

  const { payApplicationFee, payApplicationFeeError, payApplicationFeeLoading } = usePayApplicationFeeQry()

  const handleSubmit = () => {
    payApplicationFee(accountId, onSuccess)
  }

  return (
    <div className='onboarding-application-fee-info-modal'>
      <div className='onboarding-application-amount'>
        <div className='onboarding-application-amount-fee'>
          <span className='subtitle-label'>
            {tr('MERCHANTS.TRANSACTION.TYPE.ACCOUNT_SETUP_FEE', 'Application fee')}
          </span>
          <span className='subtitle-content'>
            {getCurrencySymbol(formatCurrencyForDisplay(accountSetupFee?.currency))} {accountSetupFee?.amount}
          </span>
        </div>
        <div className='onboarding-application-amount-total'>
          <span>{tr('FRONTEND.EXPENSES.TOTAL', 'Total')}</span>
          <span>
            {getCurrencySymbol(formatCurrencyForDisplay(accountSetupFee?.currency))} {accountSetupFee?.amount}
          </span>
        </div>
      </div>

      <ErrorDisplay error={payApplicationFeeError} />

      <div className='onboarding-application-divider' />

      <div className='buttons-container'>
        <CoreButton
          variation='primary-black'
          size='large'
          fullWidth
          text={tr('FRONTEND.APPLICATION_FEE.INFO.PAY.BUTTON', 'Pay')}
          data-test='button-pay'
          disabled={payApplicationFeeLoading}
          isLoading={payApplicationFeeLoading}
          onClick={handleSubmit}
        />
        <CoreButton
          variation='tertiary'
          size='large'
          text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
          data-test='button-cancel'
          disabled={payApplicationFeeLoading}
          onClick={modalHide}
        />
      </div>
    </div>
  )
}

export default ApplicationFeeInfoModal
